import { RightOutlined } from '@ant-design/icons';
import { useLocation, Link } from 'react-router-dom';

const Breadcrumb = ({ queryParams = '' }) => {
        const location = useLocation();
        const pathSegments = decodeURIComponent(location.pathname).split('/').filter(Boolean);

        const breadcrumbItems = pathSegments.map((segment, index) => {
                const path = `/${pathSegments.slice(0, index + 1).join('/')}`;
                const formattedSegment = segment.replace(/-/g, ' '); // Convert dashes to spaces

                return (
                        <div
                                key={path}
                                className="flex items-center gap-2"
                        >
                                {index > 0 && <RightOutlined className="text-gray-500" />}
                                <Link
                                        to={queryParams ? `${path}?${queryParams}` : path}
                                        className="breadcrumb-link text-sm font-semibold capitalize"
                                >
                                        {formattedSegment}
                                </Link>
                        </div>
                );
        });

        return <div className="flex gap-2">{breadcrumbItems}</div>;
};

export default Breadcrumb;
